// API for Harta (Property) data
import { API_BASE_URL, getUserDepartment } from "./base";
import { withCsrfHeaders } from "./csrf";

// Helper function to get user department and create headers
const getApiHeaders = () => {
  const userDepartment = getUserDepartment();
  return {
    "Content-Type": "application/json",
    "x-bahagian-pemantau": userDepartment,
  };
};

// Get harta for print (by zon & kategori_kutipan, with department header)
export const apiGetHartaForPrint = async ({ zon, kategori_kutipan } = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (zon) queryParams.append("zon", zon);
    if (kategori_kutipan) queryParams.append("kategori_kutipan", kategori_kutipan);
    const url = `${API_BASE_URL}/harta/print${queryParams.toString() ? `?${queryParams}` : ""}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getApiHeaders(),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching harta for print:", error);
    throw error;
  }
};

// Get harta by kod_harta
export const apiGetHartaByKodHarta = async (kodHarta) => {
  try {
    const response = await fetch(`${API_BASE_URL}/harta/kod/${encodeURIComponent(kodHarta)}`, {
      method: "GET",
      headers: getApiHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching harta by kod_harta:", error);
    throw error;
  }
};

// Get all harta with pagination
export const apiGetAllHarta = async (page = 1, limit = 10) => {
  try {
    const response = await fetch(`${API_BASE_URL}/harta?page=${page}&limit=${limit}`, {
      method: "GET",
      headers: getApiHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching harta:", error);
    throw error;
  }
};

// Search harta
export const apiSearchHarta = async (searchParams, page = 1, limit = 10) => {
  try {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    // Use only DB column names for all supported search fields
    if (searchParams.kod_harta) queryParams.append("kod_harta", searchParams.kod_harta);
    if (searchParams.nama_harta) queryParams.append("nama_harta", searchParams.nama_harta);
    if (searchParams.alamat1_harta) queryParams.append("alamat1_harta", searchParams.alamat1_harta);
    if (searchParams.alamat2_harta) queryParams.append("alamat2_harta", searchParams.alamat2_harta);
    if (searchParams.poskod_harta) queryParams.append("poskod_harta", searchParams.poskod_harta);
    if (searchParams.bandar_harta) queryParams.append("bandar_harta", searchParams.bandar_harta);
    if (searchParams.negeri_harta) queryParams.append("negeri_harta", searchParams.negeri_harta);
    if (searchParams.zon) queryParams.append("zon", searchParams.zon);
    if (searchParams.kategori_kutipan)
      queryParams.append("kategori_kutipan", searchParams.kategori_kutipan);
    if (searchParams.status_harta) queryParams.append("status_harta", searchParams.status_harta);

    const response = await fetch(`${API_BASE_URL}/harta/search?${queryParams}`, {
      method: "GET",
      headers: getApiHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error searching harta:", error);
    throw error;
  }
};

// Create new harta
export const apiCreateHarta = async (hartaData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/harta`, {
      method: "POST",
      headers: await withCsrfHeaders(getApiHeaders()),
      body: JSON.stringify(hartaData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error creating harta:", error);
    throw error;
  }
};

// Update harta
export const apiUpdateHarta = async (id, hartaData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/harta/${id}`, {
      method: "PUT",
      headers: await withCsrfHeaders(getApiHeaders()),
      body: JSON.stringify(hartaData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error updating harta:", error);
    throw error;
  }
};

// Delete harta
export const apiDeleteHarta = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/harta/${id}`, {
      method: "DELETE",
      headers: await withCsrfHeaders(getApiHeaders()),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // 204 No Content: don't try to parse JSON
    return true;
  } catch (error) {
    console.error("Error deleting harta:", error);

    throw error;
  }
};
